import React from 'react';
import { Button } from 'react-bootstrap';
import { useAppBackgroundMusic } from '../contexts/AppBackgroundMusicContext';
import { useSafeTranslation } from '../hooks/useSafeTranslation';
import './NavbarMusicToggle.css';

export interface NavbarMusicToggleProps {
  className?: string;
}

/**
 * Pausa / retoma música de fundo (playlist em shuffle definida no manifest JSON).
 * Colocar ao lado do {@link NotificationBell} nos navbars `home-navbar`.
 */
const NavbarMusicToggle: React.FC<NavbarMusicToggleProps> = ({ className }) => {
  const { t } = useSafeTranslation();
  const { isPlaying, isAvailable, toggle } = useAppBackgroundMusic();

  const label = !isAvailable
    ? t('navigation.bgmNoTracks', 'No background music configured')
    : isPlaying
      ? t('navigation.bgmPause', 'Pause music')
      : t('navigation.bgmPlay', 'Play music');

  return (
    <Button
      type="button"
      variant={isPlaying ? 'primary' : 'outline-secondary'}
      size="sm"
      className={['navbar-music-toggle d-inline-flex align-items-center justify-content-center flex-shrink-0', className].filter(Boolean).join(' ')}
      disabled={!isAvailable}
      onClick={toggle}
      title={label}
      aria-label={label}
      aria-pressed={isPlaying}
    >
      <i className={isPlaying ? 'bi bi-music-note-beamed' : 'bi bi-music-note'} aria-hidden />
    </Button>
  );
};

export default NavbarMusicToggle;
